import React from 'react'
import Categories from '../Components/Sections/Categories';
import About from '../Components/Sections/About';
import OurMenu from '../Components/Sections/OurMenu';
import Video from '../Components/Sections/Video';
import Team from '../Components/Sections/Team';
import FeedBack from '../Components/Sections/FeedBack';
import BlogPost from '../Components/Sections/BlogPost';
import HeroSection3 from '../Components/Sections/HeroSection3';
const Home3 = () => {
    return (
        <>
            <HeroSection3 />
            <Categories />
            <About />
            <OurMenu />
            <Video />
            <Team />
            <FeedBack />
            <BlogPost />
        </>
    )
}

export default Home3
